import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { PageBreadcrumbComponent } from '../../../shared/components/common/page-breadcrumb/page-breadcrumb.component';
import { CompanySectorApiService } from '../services/company-sector-api.service';
import { CompanySectorResponse } from '../models/company-sector.model';
import { AuthService } from '../../auth-pages/services/auth.service';
import { ConfirmDialogService } from '../../../shared/services/confirm-dialog.service';
import { ToastService } from '../../../shared/services/toast.service';
import { HasPermissionDirective } from '../../../shared/directives/has-permission.directive';

@Component({
  selector: 'app-company-sector-list',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    PageBreadcrumbComponent,
    HasPermissionDirective
  ],
  templateUrl: './company-sector-list.component.html'
})
export class CompanySectorListComponent implements OnInit {
  items: CompanySectorResponse[] = [];
  loading = false;
  error = '';

  constructor(
    private api: CompanySectorApiService,
    private authService: AuthService,
    private router: Router,
    private confirmDialog: ConfirmDialogService,
    private toast: ToastService
  ) {}

  ngOnInit(): void {
    this.cargar();
  }

  cargar(): void {
    this.loading = true;
    this.error = '';

    this.api.getAll().subscribe({
      next: (data) => {
        this.items = data;
        this.loading = false;
      },
      error: (err) => {
        this.error = err.error?.message || 'Error al cargar los sectores de empresa';
        this.loading = false;
        console.error('Error:', err);
      }
    });
  }

  nuevo(): void {
    this.router.navigate(['/config-empresas/sectores/crear']);
  }

  editar(item: CompanySectorResponse): void {
    this.router.navigate(['/config-empresas/sectores/editar', item.id]);
  }

  async eliminar(item: CompanySectorResponse): Promise<void> {
    const ok = await this.confirmDialog.confirmDanger({
      title: 'Eliminar sector',
      message: `¿Está seguro de eliminar el sector "${item.name}"?`
    });
    if (!ok) return;
    this.api.delete(item.id).subscribe({
      next: () => {
        this.cargar();
        this.toast.deleted('Sector', `Se eliminó "${item.name}" correctamente.`);
      },
      error: (err) => {
        this.toast.error({ title: 'Error', message: err.error?.message || 'Error al eliminar el sector' });
      }
    });
  }
}
